
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { required, email } from '@vuelidate/validators';
import store from '@/store';
import useVuelidate from '@vuelidate/core';
import config from '@/shared/constants/config';
import isFacebookApp from '@/shared/helpers/isFacebookApp';
import { urlJoin } from '@/shared/helpers/urlJoin';

export default defineComponent({
  name: 'LoginForm',
  mixins: [Form],
  emits: ['close'],
  props: {
    isModalVisible: Boolean,
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    alertText: {
      type: String,
    },
    email: {
      type: String,
    },
    returnUrl: {
      type: String,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        email: '' as string | undefined,
        password: '',
        rememberMe: false,
      },
      domain: config.DOMAIN,
      privacyUrl: config.PRIVACY_URL,
      generalTermsUrl: config.GENERAL_TERMS_URL,
    };
  },
  computed: {
    externalLoginUrl() {
      return config.EXTERNAL_LOGIN_URL + (this.returnUrl ? '?returnUrl=' + urlJoin(config.FRONT_RELATIVE_APP_URL, this.returnUrl) : '');
    },
    isFacebookApp() {
      return isFacebookApp();
    },
  },
  validations() {
    return {
      form: {
        email: { required, email },
        password: { required }, // https://jsfiddle.net/sg2zd9mf/
        rememberMe: {},
      },
    };
  },
  created() {
    this.form.email = this.email;
  },
  methods: {
    go(event, navigate) {
      event.preventDefault();
      navigate();
      this.close();
    },
    login() {
      if (!this.validate()) {
        return;
      }
      store
        .dispatch('login', this.form)
        .then(() => {
          this.close();
        })
        .catch((error) => {
          this.handleApiError(error);
        });
    },
    close() {
      this.$emit('close');
    },
  },
});
